var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptionCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.21045 1.99205C6.91396 0.849631 5.88271 0 4.64852 0C3.41437 0 2.38312 0.849631 2.08658 1.99205H0V3.32072H2.08658C2.38307 4.46315 3.41432 5.31278 4.64852 5.31278C5.88266 5.31278 6.91391 4.46315 7.21045 3.32072H21.2495V1.99205H7.21045ZM4.64852 3.98504C3.91656 3.98504 3.31985 3.38927 3.31985 2.65637C3.31985 1.92441 3.91561 1.3277 4.64852 1.3277C5.38047 1.3277 5.97626 1.92438 5.97626 2.65637C5.97626 3.38832 5.3805 3.98504 4.64852 3.98504Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.601 6.64154C15.3669 6.64154 14.3356 7.49117 14.0391 8.6336H0V9.96226H14.0391C14.3356 11.1047 15.3668 11.9543 16.601 11.9543C17.8352 11.9543 18.8664 11.1047 19.163 9.96226H21.2495V8.6336H19.163C18.8665 7.49025 17.8352 6.64154 16.601 6.64154ZM16.601 10.6257C15.8691 10.6257 15.2723 10.0299 15.2723 9.29703C15.2723 8.56507 15.8681 7.96836 16.601 7.96836C17.333 7.96836 17.9297 8.56412 17.9297 9.29703C17.9297 10.029 17.3339 10.6257 16.601 10.6257Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63294 13.2811C7.39879 13.2811 6.36754 14.1307 6.071 15.2731H0.000244141V16.6018H6.07005C6.36655 17.7442 7.3978 18.5938 8.63199 18.5938C9.86619 18.5938 10.8974 17.7442 11.1939 16.6018H21.2498V15.2731H11.1939C10.8974 14.1307 9.86711 13.2811 8.63294 13.2811ZM8.63294 17.2662C7.90098 17.2662 7.30427 16.6704 7.30427 15.9375C7.30427 15.2055 7.90003 14.6088 8.63294 14.6088C9.3649 14.6088 9.96161 15.2046 9.96161 15.9375C9.96068 16.6695 9.36492 17.2662 8.63294 17.2662Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptionCustom);
export default __webpack_public_path__ + "static/media/option-custom.349728745194a39990c4d52766b1faea.svg";
export { ForwardRef as ReactComponent };